<template>
  <div id="map-container">
    <l-map ref="map" :zoom="7" :center="bounds">
      <l-control-layers name="lControlLayers" position="topright" />
      <l-tile-layer
        v-for="tmsLayer in tmsLayers"
        :key="tmsLayer.name"
        :name="tmsLayer.name"
        :url="tmsLayer.url"
        :visible="tmsLayer.visible"
        :attribution="tmsLayer.attribution"
        layer-type="base"
      />
      <l-geo-json
        v-for="affectation in affectations"
        :key="affectation.id"
        :geojson="affectation.geometry"
        :name="affectation.description[$store.state.locale]"
        :optionsStyle="getAffectationsStyle(affectation)"
        layer-type="overlay"
      />
      <l-geo-json
        ref="parcelLayer"
        :geojson="geojson"
        :options="getStandOptions(0)"
        :optionsStyle="{
          color: '#575757',
          weight: 2,
          opacity: 0.5,
          fillColor: '#FFFFFF',
          fillOpacity: 0.4,
        }"
      />
      <l-geo-json
        v-for="(stand, index) in parcel.include_stands"
        :key="stand.id"
        :geojson="stand.geometry"
        :options="getStandOptions(index + 1)"
      />
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LGeoJson, LControlLayers } from "vue2-leaflet"
import "leaflet/dist/leaflet.css"
import StandOptionsMixin from "@/mixins/StandOptionsMixin"
import AffectationStyleMixin from "../mixins/AffectationStyleMixin"
import api from "@/api"

export default {
  name: "ParcelGeo",
  components: { LMap, LGeoJson, LControlLayers, LTileLayer },
  mixins: [StandOptionsMixin, AffectationStyleMixin],
  props: {
    parcel: Object,
  },
  computed: {
    geojson() {
      return this.$_.get(this, "parcel.parcel.geo_data", null)
    },
  },
  data() {
    return {
      bounds: [42.5, -6],
      tmsLayers: [
        {
          url: "https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg",
          visible: false,
          name: "IGN",
          attribution: "Topográfico - Instituto Geográfico Nacional",
        },
        {
          url: "https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg",
          visible: true,
          name: "Ortofoto",
          attribution: "PNOA - Instituto Geográfico Nacional",
        },
      ],
      affectations: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.map.setBounds(this.$refs.parcelLayer.getBounds())
    })
    this.getAffectations(this.parcel.id)
  },
  methods: {
    getAffectations(parcelId) {
      api.getAffectations(parcelId).then((response) => {
        this.affectations = response.data.affectations.filter(
          (oneAffectation) =>
            oneAffectation.affected && oneAffectation.geometry !== null
        )
      })
    },
  },
}
</script>
